import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  list: {
    borderRadius: 24,
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    justifyContent: 'flex-start',
    width: '100%'
  },
  listItem: {
    backgroundColor: '#f6f6fb', // var(--color-non-interactive-background-secondary)
    borderRadius: 8,
    border: '1px solid transparent', // default border-color transparent
    padding: '8px 12px',
    display: 'flex',
    flexDirection: 'row',
    gap: 4,
    alignItems: 'center',
    width: '100%'
  },
  inner: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0,
    alignItems: 'flex-start',
    justifyContent: 'center',
    width: '100%'
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    gap: 17,
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: '100%',
    minHeight: 20
  },
  topic: {
    color: '#171717',
    fontFamily: "'PlusJakartaSans-SemiBold', sans-serif",
    fontSize: 16,
    lineHeight: '24px',
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center'
  },
  list2: {
    padding: '8px 0',
    display: 'flex',
    flexDirection: 'row',
    gap: 8,
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    width: '100%',
    overflow: 'hidden'
  },
  labelStatic: {
    backgroundColor: '#ffebd6',
    borderRadius: 4,
    padding: '0 2px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start'
  },
  label: {
    padding: '0 4px 2px 4px',
    display: 'flex',
    flexDirection: 'row',
    gap: 10,
    alignItems: 'center',
    justifyContent: 'center',
    height: 20
  },
  badge: {
    color: '#793c00',
    textAlign: 'center',
    fontFamily: "'PlusJakartaSans-Medium', sans-serif",
    fontSize: 12,
    lineHeight: '20px',
    fontWeight: 500,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
}));

const ReviewList = ({
  list,
  onDifficultTopicClick,
  assignmentId,
  isStudentView = false
}) => {
  const classes = useStyles();

  return (
    <>
      {list.map((item, idx) => (
        <Button
          key={idx}
          className={classes.list}
          onClick={() => onDifficultTopicClick({ ...item, assignmentId, isStudentView })}
        >
          <div className={classes.listItem}>
            <div className={classes.inner}>
              {item.topic && (
                <div className={classes.header}>
                  <Typography className={classes.topic}>{item.topic}</Typography>
                </div>)
              }
              <div className={classes.list2}>
                {item.badges.map((badgeText, bidx) => (
                  <div key={bidx} className={classes.labelStatic}>
                    <div className={classes.label}>
                      <Typography className={classes.badge}>{badgeText}</Typography>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Button>
      ))}
    </>
  );
};

ReviewList.propTypes = {
  list: PropTypes.array,
  onDifficultTopicClick: PropTypes.func,
  assignmentId: PropTypes.number,
  isStudentView: PropTypes.bool
};

ReviewList.defaultProps = {
  list: [],
  onDifficultTopicClick: () => {},
  assignmentId: 0,
  isStudentView: false
};

export default ReviewList;

